import {RingClient, type HttpFetch} from '@phonehq/rtc-core';
import {authenticatedFetch} from '../../../services/authRuntime';
import {store} from '../../../store/store';

const ringFetch: HttpFetch = (input, init) => {
    const tenant = store.getState().auth?.tenant;
    return authenticatedFetch(input, {
        ...init,
        headers: {...(init?.headers ?? {}), ...(tenant ? {tenant} : {})},
    });
};

export const createRingClient = (): RingClient => new RingClient({
    baseUrl: window.__ENV__?.URL_CALLING_SERVICE ?? '',
    fetch: ringFetch,
    authorization: async () => undefined,
});

interface MatrixIdsBody {
    readonly data?: readonly {readonly userId: number; readonly matrixUserId: string}[];
}

export const resolveMatrixUserIds = async (userIds: readonly number[]): Promise<ReadonlyMap<number, string>> => {
    if (userIds.length === 0) {
        return new Map();
    }
    const response = await ringFetch(`${window.__ENV__?.URL_CALLING_SERVICE ?? ''}/api/v1/matrix-rtc/matrix-ids`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({userIds}),
    });
    if (!response.ok) {
        throw new Error(`Matrix ID lookup failed with HTTP ${response.status}`);
    }
    const body = await response.json() as MatrixIdsBody;
    return new Map((body.data ?? []).map(entry => [entry.userId, entry.matrixUserId]));
};
